import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';

// Move styled component outside the component to avoid recreation on every render
const ToastStyle = styled.div`
    .custom-toast {
        border-radius: 6px !important;
        padding: 12px !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        background-color: #1e1e1e !important;
        color: white !important;
        box-shadow: 0 0 8px rgba(255, 255, 255, 0.2) !important;
    }

    .custom-toast-body {
        font-size: 14px !important;
        color: white !important;
        margin: 0; 
    }

    .custom-progress-bar {
        background: white !important;
    }
`;

const ToastNotification: React.FC = () => {
    return (
        <>
            <ToastStyle>
                <ToastContainer
                    position="top-center"
                    autoClose={2500}
                    pauseOnHover
                    closeOnClick
                    toastClassName="custom-toast"
                    bodyClassName="custom-toast-body"
                    progressClassName="custom-progress-bar"
                />
            </ToastStyle>
        </>
    );
};

export default ToastNotification;
